import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-022e65c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"height":"620px"},
  class: "mx-auto"
}
const _hoisted_2 = {
  style: {"width":"340px"},
  class: "mb-48 pt-24 mx-auto"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-center mb-3" }, "Select connection", -1))
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-box__text" }, "Generate Wallet", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-box__text" }, "Metamask", -1))

import { ref } from 'vue';
import { useUserStore } from '@/store/user';
import PlugConnected from '@/assets/plug-connected.vue';
import ConnectWallet from '@/assets/connect-wallet.vue';
import GenerateWallet from '@/assets/generate-wallet.vue';
import useToastMessage from '@/composables/useToastMessage';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToastMessage();
const userStore = useUserStore();
const router = useRouter();
const hasSelectConnection = ref(false);

const selectConnection = async (caller: 'createWallet' | 'linkWallet') => {
  hasSelectConnection.value = true;
  try {
    await userStore[caller]();

    const linkReceive = localStorage.getItem('signUpForReceive');

    if (linkReceive) {
      router.push(linkReceive);
    } else {
      router.push('/landing');
    }

    localStorage.setItem('signUpForReceive', '');
  } catch (error) {
    toast.error(error);
    hasSelectConnection.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PlugConnected, { class: "mb-4" }),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "select-box hoverable",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectConnection('createWallet'))),
          "data-testid": "verify-create-wallet-btn"
        }, [
          _createVNode(GenerateWallet),
          _hoisted_5
        ]),
        _createElementVNode("div", {
          class: "select-box hoverable",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectConnection('linkWallet'))),
          "data-testid": "verify-link-wallet-btn"
        }, [
          _createVNode(ConnectWallet),
          _hoisted_6
        ])
      ])
    ])
  ]))
}
}

})